import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../utilities/AuthContext';
import { useSharedFunction } from '../utilities/SharedFunctionContext';

import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EndPoint = process.env.REACT_APP_API_ENDPOINT;

const Navigation = () => {
  const navigate = useNavigate();
  const [auth, setAuth] = useAuth();
  const hasCheckedSession = useRef(false);
  const [isOpen, setIsOpen] = useState(false);
  const [toolsOpen, setToolsOpen] = useState(false);
  const [libraryOpen, setLibraryOpen] = useState(false);
  const [forumOpen, setForumOpen] = useState(false); 
  const { data } = useSharedFunction();

  const checkSession = async () => {
    if (hasCheckedSession.current) return;

    try {
      const response = await axios.get(`${EndPoint}/session`, {
        withCredentials: true,
      });
      setAuth({ ...auth, isLoggedIn: response.data.isLoggedIn });
    } catch (error) {
      console.error('Error checking session:', error);
      setAuth({ ...auth, isLoggedIn: false });
      navigate('/');
    }

    hasCheckedSession.current = true;
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        `${EndPoint}/user/logout`,
        {},
        { withCredentials: true }
      );
      toast.success('You are logged out!', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
        hideProgressBar: false,
      });
      setAuth({ ...auth, isLoggedIn: false });
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  useEffect(() => {
    hasCheckedSession.current = false;
  }, [auth.isLoggedIn]);

  useEffect(() => {
    checkSession();
  }, []);

  useEffect(() => {
    if (data && auth.isLoggedIn) {
      setAuth((prevAuth) => ({
        ...prevAuth,
        credits: data,
      }));
    }
  }, [data, auth.isLoggedIn, setAuth]);

  // close dropdowns on outside click
  useEffect(() => {
    const onDocClick = (e) => {
      if (!(e.target.closest && e.target.closest('[data-menu="tools"]'))) {
        setToolsOpen(false);
      }
      if (!(e.target.closest && e.target.closest('[data-menu="forum"]'))) {
        setForumOpen(false);
      }
      if (!(e.target.closest && e.target.closest('[data-menu="library"]'))) {
        setLibraryOpen(false);
      }
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  return (
    <nav className="sticky top-0 bg-sky-900 flex justify-between items-center z-50 no-print p-2">
      <h1 className="text-white text-[40px] ml-4 font-semibold xs:hidden">
        Caredevo
      </h1>
      <ToastContainer />

      {/* desktop */}
      <div className="hidden lg:flex xl:flex 2xl:flex">
        {auth.isLoggedIn ? (
          <div>
      
            <button
              onClick={() => (window.location.href = 'https://caredevo.com')}
              className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl "
            >
              Home
            </button>
           
            <button
              onClick={() => navigate('/planning')}
              className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl "
            >
              Care Plan
            </button>
        
            <button
              onClick={() => navigate('/account')}
              className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl "
            >
              Account
            </button>
      
            {/* Library dropdown */}
            <div className="relative inline-block m-2" data-menu="library">
              <button
                onClick={() => setLibraryOpen((v) => !v)}
                className="text-white px-4 py-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl flex items-center gap-2"
                aria-haspopup="true"
                aria-expanded={libraryOpen}
              >
                Library
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="inline-block"
                >
                  <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
                </svg>
              </button>

              {libraryOpen && (
                <div className="absolute right-0 mt-2 w-56 rounded-xl bg-white shadow-lg ring-1 ring-black/5 py-1 z-50">
                  <button
                    onClick={() => {
                      setLibraryOpen(false);
                      navigate('/prompt');
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-100"
                  >
                    Prompt
                  </button>

                  <button
                    onClick={() => {
                      setLibraryOpen(false);
                      navigate('/library');
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-100"
                  >
                    CDM
                  </button>
                </div>
              )}
            </div>

            
            {/* admin buttons */}
            {auth && auth.role && auth.role.includes('admin') && (
              <button
                onClick={() => navigate('/log')}
                className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl "
              >
                Logs
              </button>
            )}
            {auth && auth.role && auth.role.includes('admin') && (
              <button
                onClick={() => navigate('/alluser')}
                className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl "
              >
                All User
              </button>
            )}
            {auth && auth.role && auth.role.includes('admin') && (
              <button
                onClick={() => navigate('/agreement')}
                className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl "
              >
                Agreement
              </button>
            )}
            {auth && auth.role && auth.role.includes('admin') && (
              <button
                onClick={() => navigate('/project')}
                className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl "
              >
                Project
              </button>
            )}
            {auth && auth.role && auth.role.includes('admin') && (
              <button
                onClick={() => navigate('/lead')}
                className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl "
              >
                Leads
              </button>
            )}


            {/* existing discussion button */}
             {auth && auth.role && auth.role.includes('admin') && (
            <button
              onClick={() => navigate('/community')}
              className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl "
            >
              Discussion
            </button>
             )}
            {/* NEW Forum dropdown */}
            <div
              className="relative inline-block m-2"
              data-menu="forum"
            >
              <button
                onClick={() => setForumOpen((v) => !v)}
                className="text-white px-4 py-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl flex items-center gap-2"
              >
                Forum
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="inline-block"
                >
                  <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
                </svg>
              </button>

              {forumOpen && (
                <div className="absolute right-0 mt-2 w-48 rounded-xl bg-white shadow-lg ring-1 ring-black/5 py-1 z-50">
                  <button
                    onClick={() => {
                      setForumOpen(false);
                      navigate('/feedback');
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-100"
                  >
                    Feedback
                  </button>
                  <button
                    onClick={() => {
                      setForumOpen(false);
                      navigate('/roadmap');
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-100"
                  >
                    Roadmap
                  </button>
                </div>
              )}
            </div>

            {/* Tools dropdown (existing) */}
            <div
              className="relative inline-block m-2"
              data-menu="tools"
            >
              <button
                onClick={() => setToolsOpen((v) => !v)}
                className="text-white px-4 py-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl flex items-center gap-2"
                aria-haspopup="true"
                aria-expanded={toolsOpen}
              >
                Tools
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="inline-block"
                >
                  <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
                </svg>
              </button>

              {toolsOpen && (
                <div
                  className="absolute right-0 mt-2 w-56 rounded-xl bg-white shadow-lg ring-1 ring-black/5 py-1 z-50"
                  role="menu"
                  aria-label="Tools"
                >
                  <button
                    onClick={() => {
                      setToolsOpen(false);
                      navigate('/tools');
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-100"
                    role="menuitem"
                  >
                    Psychometric Tools
                  </button>
                  <button
                    onClick={() => {
                      setToolsOpen(false);
                      navigate('/opioid');
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-100"
                    role="menuitem"
                  >
                    Opioid Calculator
                  </button>
                </div>
              )}
            </div>

            <button
              onClick={handleLogout}
              className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
            >
              Log out
            </button>
          </div>
        ) : (
          <>
            <button
              onClick={() => (window.location.href = 'https://caredevo.com')}
              className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl "
            >
              Home
            </button>

            <button
              onClick={() => navigate('/login')}
              className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
            >
              Login
            </button>
            <button
              onClick={() => navigate('/register')}
              className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
            >
              Register
            </button>
          </>
        )}
      </div>

      {/* mobile — you can add Forum here too if you want */}
      <div className="lg:hidden xl:hidden 2xl:hidden">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
        >
          Menu
        </button>

        {isOpen && (
          <div className="absolute top-14 right-0 bg-gray-900 p-4 z-10 shadow-lg w-[200px]">
            {auth.isLoggedIn ? (
              <>
                
                <button
                  onClick={() => (window.location.href = 'https://caredevo.com')}
                  className="block text-white px-2 py-2 m-0 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-xl"
                >
                  Home
                </button>

                {/* you can add Feedback/Roadmap here too if you want */}
                <button
                  onClick={() => {
                    setIsOpen(false);
                    navigate('/feedback');
                  }}
                  className="block text-white px-2 py-2 m-0 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-xl"
                >
                  Feedback
                </button>
                <button
                  onClick={() => {
                    setIsOpen(false);
                    navigate('/roadmap');
                  }}
                  className="block text-white px-2 py-2 m-0 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-xl"
                >
                  Roadmap
                </button>

                <div className="mt-1">
                  <div className="text-slate-200 px-2 pt-2 text-md">
                    Tools
                  </div>
                  <button
                    onClick={() => {
                      setIsOpen(false);
                      navigate('/tools');
                    }}
                    className="block w-full text-left text-sm text-white px-4 py-1 mx-4 my-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
                  >
                    Psychometric Tools
                  </button>
                  <button
                    onClick={() => {
                      setIsOpen(false);
                      navigate('/opioid');
                    }}
                    className="block w-full text-left text-white text-sm px-4 py-1 mx-4 my-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
                  >
                    Opioid Calculator
                  </button>
                </div>

                <button
                  onClick={() => {
                    setIsOpen(false);
                    navigate('/planning');
                  }}
                  className="block text-white text-sm px-4 py-1 mx-4 my-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
                >
                  Care Plan
                </button>


             <div className="mt-1">
                <div className="text-slate-200 text-md px-2 pt-2 ">
                  Library
                </div>

                <button
                  onClick={() => {
                    setIsOpen(false);
                    navigate('/prompt');
                  }}
                  className="block w-full text-left text-white text-sm px-4 py-1 mx-4 my-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
                >
                  Prompt
                </button>

                <button
                  onClick={() => {
                    setIsOpen(false);
                    navigate('/library');
                  }}
                  className="block w-full text-left text-white text-sm px-4 py-1 mx-4 my-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
                >
                  CDM
                </button>
              </div>

             
                {auth && auth.role && auth.role.includes('admin') && (
                  <button
                    onClick={() => {
                      setIsOpen(false);
                      navigate('/log');
                    }}
                    className="block text-white px-2 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
                  >
                    Logs
                  </button>
                )}
                {auth && auth.role && auth.role.includes('admin') && (
                  <button
                    onClick={() => {
                      setIsOpen(false);
                      navigate('/alluser');
                    }}
                    className="block text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
                  >
                    All User
                  </button>
                )}

                <button
                  onClick={handleLogout}
                  className="block text-white text-md px-2 py-2 m-0 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
                >
                  Log out
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => (window.location.href = 'https://caredevo.com')}
                  className="block text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
                >
                  Home
                </button>

                <button
                  onClick={() => navigate('/login')}
                  className="block text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
                >
                  Login
                </button>
                <button
                  onClick={() => navigate('/register')}
                  className="block text-white px-4 py-2 m-2 transition duration-300 ease-in-out focus:outline-none focus:shadow-outline hover:bg-sky-100 hover:text-slate-800 hover:rounded-2xl"
                >
                  Register
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
